export const preSeasonTeamFieldDescriptions = [
  {
    name: "name",
    label: "Name",
    fieldType: "String",
  },
  {
    name: "registeredForCup",
    label: "Pokalanmeldung",
    fieldType: "Boolean",
  },
  {
    name: "registrationFinished",
    label: "Anmeldung abgeschlossen",
    fieldType: "Boolean",
  },
  {
    name: "criteriaNotes",
    label: "Anmerkungen zu Bedingungen",
    fieldType: "Text",
  },
];
